import React, {useCallback} from "react";
import {useTextStyles} from "@rescui/typography";
// import Button from "@rescui/button";
import {useLocation} from "react-router-dom";
import {ThemeProvider} from "@rescui/ui-contexts";
import {InfoCard} from "layout/InfoCard";
import {Button} from "biggerui";
import "./index.css";

const theme = "dark";

const Login = () => {
  const textCn = useTextStyles();
  const location = useLocation();

  const handleLogin = useCallback(() => {
    // Read ?next= from query params (passed by AppRoot when redirecting here)
    const params = new URLSearchParams(location.search);
    const nextUrl = params.get("next") || "/";
    window.location.href = `/auth/login?next=${encodeURIComponent(nextUrl)}`;
  }, [location.search]);

  return (
    <ThemeProvider theme={theme}>
      <div className="login-container" style={{"--rs-theme-dark": 1}}>
        <InfoCard className="login-message">
          <h2>Please log in</h2>
          <p>You need to log in with your JetBrains account to access this site.</p>
          <Button onClick={handleLogin} size="m">
            Log in
          </Button>
        </InfoCard>
      </div>
    </ThemeProvider>
  );
};

export default Login;
